export default typeof window !== 'undefined'
  ? (window as any)
  : (global as any);
